module.exports = __webpack_public_path__ + "img/nipigas-logo.67d40651.png";